const trackbills = {
    feilds: [{
        id: 2,
        name: 'doctorid',
        text: 'Doctor Name',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Doctor',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-2 mb-2 d-flex pr-1 pl-2'
    }, {
        id: 2,
        name: 'departmentbyunit',
        text: 'Department',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Department',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-2 mb-2 d-flex pr-1 pl-2'
    }, 
    {
        id: 2,
        name: 'trackbill_statuses',
        text: 'Trigger Status',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Trigger Status',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-2 mb-2 d-flex pr-1 pl-2'
    },
    {
        id: 2,
        name: 'payer_type',
        text: 'Payer Type',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Payer Type',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-2 mb-2 d-flex pr-1 pl-2'
    }, {
        id: 2,
        name: 'bill_value',
        text: 'Bill Value',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Bill Value',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-2 mb-2 d-flex pr-1 pl-2'
    }, {
        id: 2,
        name: 'nursestationbyunit',
        text: 'Nurse Station',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Nurse Station',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-2 mb-2 d-flex pr-1 pl-2'
    }, 
    // {
    //     id: 2,
    //     name: 'ward_type',
    //     text: 'Ward Type',
    //     visible: true,
    //     element: 'select2multiple',
    //     required: true,
    //     input_type: 'select',
    //     placeholder: 'Ward Type',
    //     icon: 'user',
    //     rules: [
    //         {
    //             // test: (value) => {
    //             //     //return (value !== null && value.length > 0);
    //             //     return true;
    //             // },
    //             // message: 'Please Select Specialty'
    //         }
    //     ],
    //     errors: [],
    //     value: null,
    //     valid: false,
    //     state: '',
    //     disable: false,
    //     className: 'col-3 d-flex pr-1 pl-2'
    // },
    {
        id: 2,
        name: 'ward_name',
        text: 'Ward Type',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Ward Type',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 d-flex pr-1 pl-2'
    },
    {
        id: 2,
        name: 'due_amount',
        text: 'Due Amount',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Due Amount',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-2 mb-2 d-flex pr-1 pl-2'
    },
    {
        id: 2,
        name: 'due_percent',
        text: 'Due Percent',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Due Percent',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-2 mb-2 d-flex pr-1 pl-2'
    },
    {
        id: 2,
        name: 'work_list_type',
        text: 'Bill Type',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Bill Type',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-2 mb-2 d-flex pr-1 pl-2'
    }, 
    {
        id: 1,
        name: 'search',
        text: 'IP or UMR No:',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'input',
        placeholder: 'Patient’s Name or IP Number',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     return (value !== null && value.length > 0);
                // },
                // message: 'Please Select Your Appointment Date'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mb-2 d-flex pr-1 pl-2'
    },
    
    ]
}

const formDataSchema = {
    feilds: [
        {
            id: 1,
            name: 'search',
            text: 'IP or UMR No:',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'input',
            placeholder: 'Patient’s Name or IP Number',
            icon: 'user',
            rules: [
                {
                    // test: (value) => {
                    //     return (value !== null && value.length > 0);
                    // },
                    // message: 'Please Select Your Appointment Date'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-10 pr-0'
        }, {
            id: 2,
            name: 'date',
            text: 'Date',
            visible: true,
            element: 'daterange',
            required: true,
            input_type: 'date',
            placeholder: 'Select Date',
            icon: 'user',
            rules: [
                // {
                //     test: (value) => {
                //         return (value !== null && value.length > 0);
                //     },
                //     message: 'Please Select  Date'
                // }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4 d-flex pr-0 float-right'
        }
    ]
}

const patientPendingSchema = {
    feilds: [
        {
            id: 1,
            name: 'search',
            text: 'IP or UMR No:',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'input',
            placeholder: 'Patient’s Name or IP Number',
            icon: 'user',
            rules: [
                {
                    // test: (value) => {
                    //     return (value !== null && value.length > 0);
                    // },
                    // message: 'Please Select Your Appointment Date'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3 pr-0'
        }, {
            id: 2,
            name: 'doctorid',
            text: 'Doctor Name',
            visible: true,
            element: 'select2multiple',
            required: true,
            input_type: 'select',
            placeholder: 'Doctor',
            icon: 'user',
            rules: [
                {
                    // test: (value) => {
                    //     //return (value !== null && value.length > 0);
                    //     return true;
                    // },
                    // message: 'Please Select Specialty'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3 mb-2 d-flex pr-1 pl-2'
        }, {
            id: 3,
            name: 'pendingDocs_departmentbyunit',
            text: 'Department',
            visible: true,
            element: 'select2multiple',
            required: true,
            input_type: 'select',
            placeholder: 'Department',
            icon: 'user',
            rules: [
                {
                    // test: (value) => {
                    //     //return (value !== null && value.length > 0);
                    //     return true;
                    // },
                    // message: 'Please Select Specialty'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3 mb-2 d-flex pr-1 pl-2'
        }, {
            id: 4,
            name: 'pre_auth_submitted',
            text: 'Pre-Auth Submitted',
            visible: true,
            element: 'select2multiple',
            required: true,
            input_type: 'select',
            placeholder: 'Pre-Auth Submitted',
            icon: 'user',
            rules: [
                {
                    // test: (value) => {
                    //     //return (value !== null && value.length > 0);
                    //     return true;
                    // },
                    // message: 'Please Select Specialty'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3 mb-2 d-flex pr-1 pl-2'
        },
        {
            id: 5,
            name: 'insurance_status',
            text: 'Insurance Status',
            visible: true,
            element: 'select2multiple',
            required: true,
            input_type: 'select',
            placeholder: 'Insurance Status',
            icon: 'user',
            rules: [
                {
                    // test: (value) => {
                    //     //return (value !== null && value.length > 0);
                    //     return true;
                    // },
                    // message: 'Please Select Specialty'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3 mb-2 d-flex pr-1 pl-2'
        },
        {
            id: 6,
            name: 'fc_payer_type',
            text: 'FC Payer Type',
            visible: true,
            element: 'select2multiple',
            required: true,
            input_type: 'select',
            placeholder: 'FC Payer Type',
            icon: 'user',
            rules: [
                {
                    // test: (value) => {
                    //     //return (value !== null && value.length > 0);
                    //     return true;
                    // },
                    // message: 'Please Select Specialty'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3 mb-2 d-flex pr-1 pl-2'
        },
        {
            id: 7,
            name: 'payer_type',
            text: 'HIMS Payer Type',
            visible: true,
            element: 'select2multiple',
            required: true,
            input_type: 'select',
            placeholder: 'HIMS Payer Type',
            icon: 'user',
            rules: [
                {
                    // test: (value) => {
                    //     //return (value !== null && value.length > 0);
                    //     return true;
                    // },
                    // message: 'Please Select Specialty'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3 mb-2 d-flex pr-1 pl-2'
        },
        {
            id: 8,
            name: 'pre_auth_Daterage',
            text: 'Date',
            visible: true,
            element: 'daterange',
            required: true,
            input_type: 'date',
            placeholder: 'Select Date',
            icon: 'user',
            rules: [
                // {
                //     test: (value) => {
                //         return (value !== null && value.length > 0);
                //     },
                //     message: 'Please Select  Date'
                // }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3    d-flex pr-1 pl-2 float-right mb-2'
        }
    ]
}
const patientHistorySchema = {
    feilds: [
        {
            id: 1,
            name: 'search',
            text: 'IP or UMR No:',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'input',
            placeholder: 'Patient’s Name or IP Number',
            icon: 'user',
            rules: [
                {
                    // test: (value) => {
                    //     return (value !== null && value.length > 0);
                    // },
                    // message: 'Please Select Your Appointment Date'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-10 pr-0'
        }
    ]
}

const dueworklistSchema = {
    feilds: [{
        id: 2,
        name: 'doctorid',
        text: 'Doctor Name',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Doctor',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4 mb-2 d-flex pr-1 pl-2'
    }, {
        id: 2,
        name: 'departmentbyunit',
        text: 'Department',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Department',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4 mb-2 d-flex pr-1 pl-2'
    }, {
        id: 2,
        name: 'nursestationbyunit',
        text: 'Nurse Station',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Nurse Station',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4 d-flex pr-1 pl-2'
    }, {
        id: 2,
        name: 'due_payer_type',
        text: 'Payer Type',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Payer Type',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4 d-flex pr-1 pl-2'
    }, {
        id: 2,
        name: 'bill_value',
        text: 'Due Amount',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Due Amount',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4 d-flex pr-1 pl-2'
    }, {
        id: 2,
        name: 'due_percent',
        text: 'Due Percent',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Due Percent',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4 d-flex pr-1 pl-2'
    }

]
}

const consentpatientSchema = {
    feilds: [{
        id: 1,
        name: 'doctorid',
        text: 'Doctor Name',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Doctor',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mb-2 d-flex pr-1 pl-2'
    }, {
        id: 2,
        name: 'departmentbyunit',
        text: 'Department',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Department',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mb-2 d-flex pr-1 pl-2'
    }, {
        id: 3,
        name: 'payer_type',
        text: 'Payer Type',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Payer Type',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mb-2 d-flex pr-1 pl-2'
    },
    {
        id: 4,
        name: 'search',
        text: 'IP or UMR No:',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'input',
        placeholder: 'Patient Name or UMR or IP',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     return (value !== null && value.length > 0);
                // },
                // message: 'Please Select Your Appointment Date'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 d-flex pr-1 pl-2'
    },
    {
        id: 5,
        name: 'nursestationbyunit',
        text: 'Nurse Station',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Nurse Station',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 d-flex pr-1 pl-2'
    },
    {
        id: 6,
        name: 'counsellor_submitted',
        text: 'Counsellor Submitted',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Counsellor Submitted',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 d-flex pr-1 pl-2'
    },
    {
        id: 7,
        name: 'date',
        text: 'Date',
        visible: true,
        element: 'daterange',
        required: true,
        input_type: 'date',
        placeholder: 'Select Date',
        icon: 'user',
        rules: [
            // {
            //     test: (value) => {
            //         return (value !== null && value.length > 0);
            //     },
            //     message: 'Please Select  Date'
            // }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-6 d-flex pr-0 float-right'
    },
   
    ]
}

const investigationsSchema = {
    feilds: [{
        id: 1,
        name: 'services',
        header: 1,
        header_amount: 0,
        title: 'services',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Name', width: "30%" }, { 'id': 3, 'text': 'Status', width: "30%" }, { 'id': 4, 'text': 'Reason', width: "10%" }, { 'id': 5, 'text': 'General Price (Rs.)', width: "12%" }, { 'id': 5, 'text': 'Price (Rs.)', width: "13%" }],
            'table_body': [],
            'add_more_feilds': [{
                'id': 1,
                'key_word': 'room',
                'feilds': [{
                    id: 1,
                    service: 1,
                    sub_header: 1,
                    name: 'name',
                    title: 'name',
                    visible: true,
                    element: 'text',
                    row_group: 'room',
                    table: 'services',
                }, {
                    id: 2,
                    name: 'status',
                    title: 'Status',
                    visible: true,
                    icon: 'number',
                    element: 'radio',
                    required: true,
                    type: 'radio',
                    placeholder: 'Status',
                    rules: [{
                        test: (value) => {
                            return (value !== null && value.length > 0 && value != '');
                        },
                        message: 'Select Status'
                    }],
                    data: [{
                        id: 1,
                        name: 'approve',
                        title: 'Approve',
                        visible: true,
                        icon: 'number',
                        element: 'radio',
                        required: true,
                        type: 'radio',
                        placeholder: 'Approve',
                        rules: [],
                        errors: [],
                        value: null,
                        valid: false,
                        state: '',
                        disable: false,
                        className: 'col-3',
                        row_group: 'room',
                        table: 'services',
                    }, {
                        id: 2,
                        name: 'rejecte',
                        title: 'Rejecte',
                        visible: true,
                        icon: 'number',
                        element: 'radio',
                        required: true,
                        type: 'radio',
                        placeholder: 'Rejecte',
                        rules: [],
                        errors: [],
                        value: null,
                        valid: false,
                        state: '',
                        disable: false,
                        className: 'col-3',
                        row_group: 'room',
                        table: 'services',
                    }],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'room',
                    table: 'services',
                }, {
                    id: 3,
                    name: 'consent_reason',
                    title: 'Reason',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Reason',
                    rules: [{
                        test: (value) => {
                            return (value !== null && value.length > 0 && value != '');
                        },
                        message: 'Select Reason'
                    }],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'room',
                    table: 'services',
                }, {
                    id: 4,
                    name: 'general_price',
                    title: 'Default Price',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Amount',
                    rules: [{
                        test: (value) => {
                            return (value !== null && value.length > 0 && value != '');
                        },
                        message: 'Enter Amount'
                    }],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'room',
                    table: 'services',
                },
                {
                    id: 5,
                    name: 'price',
                    title: 'Price',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Amount',
                    rules: [{
                        test: (value) => {
                            return (value !== null && value.length > 0 && value != '');
                        },
                        message: 'Enter Amount'
                    }],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'room',
                    table: 'services',
                },
                ]
            }],
        }
    }]
}

const proceduresSchema = {
    feilds: [{
        id: 1,
        name: 'procedures',
        header: 1,
        header_amount: 0,
        title: 'procedures',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Name', width: "30%" }, { 'id': 3, 'text': 'Status', width: "30%" }, { 'id': 4, 'text': 'Reason', width: "10%" }, { 'id': 5, 'text': 'General Price (Rs.)', width: "12%" }, { 'id': 5, 'text': 'Price (Rs.)', width: "13%" }],
            'table_body': [],
            'add_more_feilds': [{
                'id': 1,
                'key_word': 'room',
                'feilds': [{
                    id: 1,
                    service: 1,
                    sub_header: 1,
                    name: 'name',
                    title: 'name',
                    visible: true,
                    element: 'text',
                    row_group: 'room',
                    table: 'procedures',
                }, {
                    id: 2,
                    name: 'status',
                    title: 'Status',
                    visible: true,
                    icon: 'number',
                    element: 'radio',
                    required: true,
                    type: 'radio',
                    placeholder: 'Status',
                    rules: [{
                        test: (value) => {
                            return (value !== null && value.length > 0 && value != '');
                        },
                        message: 'Select Status'
                    }],
                    data: [{
                        id: 1,
                        name: 'approve',
                        title: 'Approve',
                        visible: true,
                        icon: 'number',
                        element: 'radio',
                        required: true,
                        type: 'radio',
                        placeholder: 'Approve',
                        rules: [],
                        errors: [],
                        value: null,
                        valid: false,
                        state: '',
                        disable: false,
                        className: 'col-3',
                        row_group: 'room',
                        table: 'procedures',
                    }, {
                        id: 2,
                        name: 'rejecte',
                        title: 'Rejecte',
                        visible: true,
                        icon: 'number',
                        element: 'radio',
                        required: true,
                        type: 'radio',
                        placeholder: 'Rejecte',
                        rules: [],
                        errors: [],
                        value: null,
                        valid: false,
                        state: '',
                        disable: false,
                        className: 'col-3',
                        row_group: 'room',
                        table: 'procedures',
                    }],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'room',
                    table: 'procedures',
                }, {
                    id: 3,
                    name: 'consent_reason',
                    title: 'Reason',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Reason',
                    rules: [{
                        test: (value) => {
                            return (value !== null && value.length > 0 && value != '');
                        },
                        message: 'Select Reason'
                    }],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'room',
                    table: 'procedures',
                }, {
                    id: 4,
                    name: 'general_price',
                    title: 'Default Price',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Amount',
                    rules: [{
                        test: (value) => {
                            return (value !== null && value.length > 0 && value != '');
                        },
                        message: 'Enter Amount'
                    }],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'room',
                    table: 'services',
                },
                {
                    id: 5,
                    name: 'price',
                    title: 'Price',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Amount',
                    rules: [{
                        test: (value) => {
                            return (value !== null && value.length > 0 && value != '');
                        },
                        message: 'Enter Amount'
                    }],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'room',
                    table: 'procedures',
                }]
            }],
        }
    }]
}

const drugsSchema = {
    feilds: [{
        id: 1,
        name: 'drugs',
        header: 1,
        header_amount: 0,
        title: 'drugs',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Name', width: "30%" }, { 'id': 3, 'text': 'Status', width: "35%" }, { 'id': 4, 'text': 'Reason', width: "5%" }, { 'id': 5, 'text': 'Quantity', width: "5%" }, { 'id': 6, 'text': 'General Price (Rs.)', width: "10%" }, { 'id': 7, 'text': 'Price (Rs.)', width: "10%" }],
            'table_body': [],
            'add_more_feilds': [{
                'id': 1,
                'key_word': 'room',
                'feilds': [{
                    id: 1,
                    service: 1,
                    sub_header: 1,
                    name: 'name',
                    title: 'name',
                    visible: true,
                    element: 'text',
                    row_group: 'room',
                    table: 'drugs',
                }, {
                    id: 2,
                    name: 'status',
                    title: 'Status',
                    visible: true,
                    icon: 'number',
                    element: 'radio',
                    required: true,
                    type: 'radio',
                    placeholder: 'Status',
                    rules: [{
                        test: (value) => {
                            return (value !== null && value.length > 0 && value != '');
                        },
                        message: 'Select Status'
                    }],
                    data: [{
                        id: 1,
                        name: 'approve',
                        title: 'Approve',
                        visible: true,
                        icon: 'number',
                        element: 'radio',
                        required: true,
                        type: 'radio',
                        placeholder: 'Approve',
                        rules: [],
                        errors: [],
                        value: null,
                        valid: false,
                        state: '',
                        disable: false,
                        className: 'col-3',
                        row_group: 'room',
                        table: 'drugs',
                    }, {
                        id: 2,
                        name: 'rejecte',
                        title: 'Rejecte',
                        visible: true,
                        icon: 'number',
                        element: 'radio',
                        required: true,
                        type: 'radio',
                        placeholder: 'Rejecte',
                        rules: [],
                        errors: [],
                        value: null,
                        valid: false,
                        state: '',
                        disable: false,
                        className: 'col-3',
                        row_group: 'room',
                        table: 'drugs',
                    }],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'room',
                    table: 'drugs',
                }, {
                    id: 3,
                    name: 'consent_reason',
                    title: 'Reason',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Reason',
                    rules: [{
                        test: (value) => {
                            return (value !== null && value.length > 0 && value != '');
                        },
                        message: 'Select Reason'
                    }],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'room',
                    table: 'drugs',
                }, {
                    id: 4,
                    name: 'quantity',
                    title: 'Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Quantity',
                    rules: [{
                        test: (value) => {
                            return (value !== null && value.length > 0 && value != '');
                        },
                        message: 'Enter Quantity'
                    }],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'room',
                    table: 'drugs',
                }, {
                    id: 4,
                    name: 'price',
                    title: 'Price',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Amount',
                    rules: [{
                        test: (value) => {
                            return (value !== null && value.length > 0 && value != '');
                        },
                        message: 'Enter Amount'
                    }],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'room',
                    table: 'drugs',
                }, {
                    id: 4,
                    name: 'total_amount',
                    title: 'Total Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Amount',
                    rules: [{
                        test: (value) => {
                            return (value !== null && value.length > 0 && value != '');
                        },
                        message: 'Enter Amount'
                    }],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'room',
                    table: 'drugs',
                }]
            }],
        }
    }]
}
const interim_enhacement_search = {
    feilds: [
        {
            id: 1,
            name: 'search',
            text: 'IP or UMR No:',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'input',
            placeholder: 'Patient’s Name or IP Number',
            icon: 'user',
            rules: [
                {
                    // test: (value) => {
                    //     return (value !== null && value.length > 0);
                    // },
                    // message: 'Please Select Your Appointment Date'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4 pr-0 mx-auto'
        }
    ]
}
const callLogSchemaDue = {
    feilds: [
        {
            id: 1,
            name: 'remarks',
            title: 'Remarks',
            visible: true,
            element: 'radio',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: 'remarks',
            valid: false,
            state: '',
            disable: false,
            className: 'col-4 '
        },
        {
            id: 2,
            name: 'calldata',
            title: 'Call Log',
            visible: true,
            element: 'radio',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3 p-0 '
        },
        {
            id: 3,
            name: 'activity_type',
            title: 'Activity Type*',
            visible: true,
            element: 'select2',
            required: false,
            type: 'select',
            placeholder: 'Select',
            icon: 'user',
            rules: [{
                test: (value) => {
                    return (value !== null && value.length > 0 && value != '');
                },
                message: 'Please Select Category'
            }],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4 mt-3 ',
            message: 'Please select Category'
        }, {
            id: 4,
            name: 'category',
            title: 'Category*',
            visible: true,
            element: 'select2',
            required: false,
            type: 'select',
            placeholder: 'Select',
            icon: 'user',
            rules: [{
                test: (value) => {
                    return (value !== null && value.length > 0 && value != '');
                },
                message: 'Please Select Category'
            }],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-4 mt-3 ',
            message: 'Please select Category'
        }
    ]
}
const estimateVariance = {
    feilds: [{
        id: 1,
        name: 'doctorid',
        text: 'Doctor Name',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Doctor',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mb-2 d-flex pr-1 pl-2'
    }, {
        id: 2,
        name: 'departmentbyunit',
        text: 'Department',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Department',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mb-2 d-flex pr-1 pl-2'
    }, {
        id: 3,
        name: 'payer_type',
        text: 'Payer Type',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Payer Type',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mb-2 d-flex pr-1 pl-2'
    },
    {
        id: 4,
        name: 'variance',
        text: 'Variance',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Variance',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mb-2 d-flex pr-1 pl-2'
    },

    {
        id: 5,
        name: 'nursestationbyunit',
        text: 'Nurse Station',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Nurse Station',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 d-flex pr-1 pl-2'
    }, {
        id: 6,
        name: 'ward_type',
        text: 'Ward Type',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Ward Type',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 d-flex pr-1 pl-2'
    },

    {
        id: 7,
        name: 'search',
        text: 'IP or UMR No:',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'input',
        placeholder: 'Patient’s Name or IP Number',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     return (value !== null && value.length > 0);
                // },
                // message: 'Please Select Your Appointment Date'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 d-flex pr-1 pl-2'
    },
    {
        id: 8,
        name: 'date',
        text: 'Date',
        visible: true,
        element: 'daterange',
        required: true,
        input_type: 'date',
        placeholder: 'Select Date',
        icon: 'user',
        rules: [
            // {
            //     test: (value) => {
            //         return (value !== null && value.length > 0);
            //     },
            //     message: 'Please Select  Date'
            // }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 d-flex pr-1 pl-2 float-right'
    }
    ]
}
const InsurancePendingSchema = {
    feilds: [
        {
            id: 1,
            name: 'search',
            text: 'IP or UMR No:',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'input',
            placeholder: 'Patient’s Name or IP Number',
            icon: 'user',
            rules: [
                {
                    // test: (value) => {
                    //     return (value !== null && value.length > 0);
                    // },
                    // message: 'Please Select Your Appointment Date'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3 pr-0'
        }, {
            id: 2,
            name: 'doctorid',
            text: 'Doctor Name',
            visible: true,
            element: 'select2multiple',
            required: true,
            input_type: 'select',
            placeholder: 'Doctor',
            icon: 'user',
            rules: [
                {
                    // test: (value) => {
                    //     //return (value !== null && value.length > 0);
                    //     return true;
                    // },
                    // message: 'Please Select Specialty'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3 mb-2 d-flex pr-1 pl-2'
        }, {
            id: 3,
            name: 'pendingDocs_departmentbyunit',
            text: 'Department',
            visible: true,
            element: 'select2multiple',
            required: true,
            input_type: 'select',
            placeholder: 'Department',
            icon: 'user',
            rules: [
                {
                    // test: (value) => {
                    //     //return (value !== null && value.length > 0);
                    //     return true;
                    // },
                    // message: 'Please Select Specialty'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3 mb-2 d-flex pr-1 pl-2'
        }, {
            id: 4,
            name: 'pre_auth_submitted',
            text: 'Pre-Auth Submitted',
            visible: true,
            element: 'select2multiple',
            required: true,
            input_type: 'select',
            placeholder: 'Pre-Auth Submitted',
            icon: 'user',
            rules: [
                {
                    // test: (value) => {
                    //     //return (value !== null && value.length > 0);
                    //     return true;
                    // },
                    // message: 'Please Select Specialty'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3 mb-2 d-flex pr-1 pl-2'
        },
        {
            id: 5,
            name: 'insurance_status',
            text: 'Insurance Status',
            visible: true,
            element: 'select2multiple',
            required: true,
            input_type: 'select',
            placeholder: 'Insurance Status',
            icon: 'user',
            rules: [
                {
                    // test: (value) => {
                    //     //return (value !== null && value.length > 0);
                    //     return true;
                    // },
                    // message: 'Please Select Specialty'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3 mb-2 d-flex pr-1 pl-2'
        },
        {
            id: 6,
            name: 'fc_payer_type',
            text: 'FC Payer Type',
            visible: true,
            element: 'select2multiple',
            required: true,
            input_type: 'select',
            placeholder: 'FC Payer Type',
            icon: 'user',
            rules: [
                {
                    // test: (value) => {
                    //     //return (value !== null && value.length > 0);
                    //     return true;
                    // },
                    // message: 'Please Select Specialty'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3 mb-2 d-flex pr-1 pl-2'
        },
        {
            id: 7,
            name: 'payer_type',
            text: 'HIMS Payer Type',
            visible: true,
            element: 'select2multiple',
            required: true,
            input_type: 'select',
            placeholder: 'HIMS Payer Type',
            icon: 'user',
            rules: [
                {
                    // test: (value) => {
                    //     //return (value !== null && value.length > 0);
                    //     return true;
                    // },
                    // message: 'Please Select Specialty'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3 mb-2 d-flex pr-1 pl-2'
        },
        {
            id: 8,
            name: 'pre_auth_Daterage',
            text: 'Date',
            visible: true,
            element: 'daterange',
            required: true,
            input_type: 'date',
            placeholder: 'Select Date',
            icon: 'user',
            rules: [
                // {
                //     test: (value) => {
                //         return (value !== null && value.length > 0);
                //     },
                //     message: 'Please Select  Date'
                // }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3    d-flex pr-1 pl-2 float-right mb-2'
        },{
            id: 9,
            name: 'assignedFrom',
            title: 'Assigned From*',
            visible: true,
            element: 'select2multiple',
            required: false,
            type: 'select',
            placeholder: 'Assigned From',
            icon: 'user',
            rules: [{
                test: (value) => {
                    return (value !== null && value.length > 0 && value != '');
                },
                message: 'Please Select Assigned From'
            }],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3 mb-2 d-flex pr-1 pl-2',
        }
    ]
}
export { formDataSchema, trackbills, patientPendingSchema, patientHistorySchema, dueworklistSchema, consentpatientSchema, investigationsSchema, proceduresSchema, drugsSchema, interim_enhacement_search, callLogSchemaDue, estimateVariance, InsurancePendingSchema };